import React from "react";

import Avatar		from "../common/components/Avatar";
import MessageBox	from "../common/components/MessageBox";

function NotFound(props) {
	return (
		<div className="u-height100 u-flex u-flexJustifyCenter u-flexAlignItemsCenter">
			<Avatar width={280} />
			<MessageBox headerText="404">La page est introuvable</MessageBox>
		</div>
	);
}

export default NotFound;


// WEBPACK FOOTER //
// ./src/js/not-found/index.js